import { z } from "zod";
export const ControlledAiGapDetectorResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-gap-detector.v1.0"),
    requirementId: z.literal("AI-003"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function detectAiGaps(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiGapDetectorResultV1Schema.parse({
        schemaVersion: "controlled-ai-gap-detector.v1.0",
        requirementId: "AI-003",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=gap-detector.js.map